module.exports = __webpack_public_path__ + "static/media/ic-close.718e4d5c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/citylink/ic-close.svg
// module id = 675
// module chunks = 0